<div class="flex-column f-1-0 bg-white animated fadeIn" style="overflow: auto;">
	<div class="flex-row justify-content-between gap-3 align-items-center px-3 py-2 ai-chat-meta"
		 *ngIf="!isHeadless">
		<div class="flex-row gap-2 align-items-center">
			<div class="flex-row centralize static-color ai-chat-avatar">
				<img class="static-image-color" src="images/ai-bot-avatar.png" alt="">
			</div>
			<div class="flex-column">
				<span class="fw-500 ai-chat-meta-role">Trustifi AI</span>
				<span class="ai-chat-meta-idx">Support assistant</span>
			</div>
		</div>

		<div class="flex-row gap-1 align-items-center ai-chat-actions">
			<i class="far fa-edit animated fadeIn"
			   *ngIf="conversation.length > 1"
			   tooltip="Start new chat"
			   (click)="resetConversation();"></i>
			<i class="zmdi zmdi-close"
			   (click)="closeCb.emit();"></i>
		</div>

	</div>

	<!-- CHAT VIEW -->
	<div class="flex-column f-1-0 ai-chat" style="min-height: 0;">
		<!-- MESSAGES -->
		<div class="flex-column f-1-0 gap-3 ai-chat-messages thin-scrollbar" style="min-height: 0;"
			 #chatMessagesContainer>
			<ng-container *ngIf="conversation?.length > 1; else emptyState">

				<!-- CC: index 0 is the bot greeting - it is presented by the welcome screen, not as a bubble -->
				<ng-container *ngFor="let item of conversation; let index = index; trackBy: gs.trackByIndex;">
					<div
						*ngIf="index !== 0"
						class="flex-row animated fadeIn ai-chat-row"
						[class.justify-content-end]="item.role === 'user'"
						[class.justify-content-start]="item.role === 'assistant'"
					>

						<!-- Bubble -->
						<div class="flex-column gap-1" [ngClass]="item.role === 'user' ? 'ai-chat-bubble-wrap-user' : 'ai-chat-bubble-wrap'">
							<div class="flex-column gap-2 ai-chat-bubble" [class.ai-chat-bubble-user]="item.role === 'user'">
								<div class="ai-chat-text" (click)="openLinksInNewTab($event)" [innerHTML]="item.sanitizedMessage"></div>
								<a *ngIf="item.reference" class="flex-row gap-1 align-items-center align-self-start blue-link" style="font-size: 13px;"
								   [href]="item.reference" target="_blank"
								   rel="noopener noreferrer">
									<i class="far fa-external-link"></i>
									<u>View reference</u>
								</a>
							</div>
							<div class="ai-chat-actions flex-row gap-1 align-items-center" *ngIf="item.role !== 'user'">
								<i class="far fa-clone copy-link" tooltip="Copy" (click)="copyMessageToClipboard(item.message);"></i>
								<i class="far fa-thumbs-up" tooltip='Good response' (click)="likeMessage(item, true);"
								   [ngClass]="{'color-primary' : item.likeState === 'positive'}"></i>
								<i class="far fa-thumbs-down" tooltip='Bad response' (click)="likeMessage(item, false);"
								   [ngClass]="{'color-primary' : item.likeState === 'negative'}"></i>
								<i class="far fa-save copy-link" tooltip="Export chat"
								   *ngIf="item.role === 'assistant' && (index === conversation.length || index === conversation.length - 1)"
								   (click)="exportConversation();"></i>
							</div>
						</div>
					</div>
				</ng-container>

				<!-- Thinking indicator -->
				<div class="flex-row gap-2 align-items-center justify-content-start ai-chat-row ai-chat-thinking"
					*ngIf="inProcess">
					<div class="flex-row centralize static-color ai-chat-avatar">
						<img class="static-image-color" src="images/ai-bot-avatar.png" alt="">
					</div>

					<div class="flex-row align-items-center gap-1 ai-chat-bubble ai-chat-thinking-bubble">
						<span class="ai-chat-dot"></span>
						<span class="ai-chat-dot ai-chat-dot-2"></span>
						<span class="ai-chat-dot ai-chat-dot-3"></span>
					</div>
				</div>

				<!--padder-->
				<div style="min-height: 50%;" *ngIf="inProcess"></div>

			</ng-container>

			<ng-template #emptyState>
				<div class="flex-column f-1-0 gap-3 animated fadeIn ai-chat-empty">
					<div class="flex-column f-1-0 centralize gap-3 text-center">
						<div class="flex-row centralize static-color ai-chat-avatar">
							<img class="static-image-color" src="images/ai-bot-avatar.png" alt="">
						</div>
						<div class="flex-column gap-2">
							<span class="fw-500 ai-chat-empty-title">Hi! I’m the Trustifi Support Assistant</span>
							<span class="ai-chat-empty-sub">Describe your issue in detail — I have access to your account logs, diagnostic tools, and our full knowledge base, so the more you share, the faster I can help.</span>
						</div>
						<div class="flex-column gap-2 text-start ai-chat-empty-sub" *ngIf="showTicketLabels">
							<div class="flex-row gap-2 align-items-start">
								<i class="far fa-check-circle text-success"></i>
								<span>Over 75% of issues are resolved right here — no waiting for a human</span>
							</div>
							<div class="flex-row gap-2 align-items-start">
								<i class="far fa-headset text-primary"></i>
								<span>Not resolved? One click opens a ticket — your full conversation is included so engineers know exactly what’s going on</span>
							</div>
						</div>
					</div>

					<div class="flex-column gap-2">
						<button type="button" class="flex-row gap-2 align-items-center text-start ai-chat-empty-card"
								*ngFor="let suggestion of suggestions; trackBy: gs.trackByIndex;"
								(click)="aiAssistantExecute(suggestion.text);">
							<i [class]="suggestion.icon"></i>
							<span class="f-1-0">{{suggestion.text}}</span>
						</button>
					</div>
				</div>
			</ng-template>
		</div>

		<!-- INPUT -->
		<div class="flex-column gap-2 px-3 pb-3 pt-2">
			<div class="flex-column ai-chat-input" (click)="questionInput.focus();">
				<textarea
					#questionInput
					id="questionInputEl"
					class="thinner-scrollbar ai-chat-textarea"
					placeholder="Describe your issue or ask a question…"
					[(ngModel)]="chatInputTxt"
					[disabled]="inProcess"
					[appAutoFocus]="true"
					[focusDelay]="150"
					(keydown.enter)="!$event.shiftKey && $event.preventDefault()"
					(keyup.enter)="!$event.shiftKey && aiAssistantExecute(chatInputTxt)"
					rows="3"
				></textarea>

				<div class="flex-row justify-content-end align-items-center">
					<button
						type="button"
						class="ai-chat-send"
						[disabled]="inProcess || !chatInputTxt"
						(click)="aiAssistantExecute(chatInputTxt);"
						title="Send">
						<i class="far fa-paper-plane"></i>
					</button>
				</div>
			</div>

			<div class="text-center ai-chat-hint" *ngIf="gs.showSupportMenu && !isHeadless">
				Didn't find what you need? <a class="blue-link text-decoration-underline" (click)="goToTicketsPage();">Open a support ticket</a>
			</div>
		</div>

	</div>
</div>
